import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { BaasAutoNumericInput, BaasAutoNumericOptions } from '@lvflanders/bar-ng-ui';

import { BarBaseInputCellEditor } from '../bar-base-input-cell-editor';
import { IBarAutoNumericCellEditorParams } from './bar-auto-numeric-cell-editor-params.contract';

@Component({
    selector: 'bar-auto-numeric-cell-editor',
    templateUrl: './bar-auto-numeric-cell-editor.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormFieldModule, MatInputModule, FormsModule, BaasAutoNumericInput, ReactiveFormsModule]
})
/** AG grid editor for auto numeric fields. */
export class BarAutoNumericCellEditor extends BarBaseInputCellEditor<IBarAutoNumericCellEditorParams> {
    readonly autoNumeric = viewChild.required(BaasAutoNumericInput);

    protected options: BaasAutoNumericOptions;

    protected onInit(): void {
        this.options = this.params.options;
    }

    // NOTE in case in renderer mode going to editor mode, which character do we allow to be typed in
    protected isAllowedCharacter(eventKey: string): boolean {
        const negativeSignCharacter = this.options.negativeSignCharacter || '-';
        const decimalCharacter = this.options.decimalCharacter || '.';
        const allowNegative = this.options.minimumValue == null || this.options.minimumValue < 0;
        const allowDecimal = this.options.decimalPlaces > 0;
        return /\d/.test(eventKey) || (eventKey === negativeSignCharacter && allowNegative) || (eventKey === decimalCharacter && allowDecimal);
    }
}
